import { useQuery } from "@tanstack/react-query";
import * as api from "../endpoints";

export function usePublicPositions(params: api.PublicPositionListParams) {
  return useQuery({
    queryKey: ["publicPositions", params],
    queryFn: () => api.listPositions(params),
    staleTime: 60_000,
  });
}

export function usePublicPosition(id: number | null) {
  return useQuery({
    queryKey: ["publicPosition", id],
    queryFn: () => api.getPosition(id!),
    enabled: id != null,
    staleTime: 60_000,
  });
}
